import React from 'react';

import qs from 'query-string';
import styles from './SavingGroupDeepLinkingPrompt.module.css';

export default ({
  translations,
  location,
  setSavingGroupDeepLinkingPromptShow
}) => {
  const query = qs.parse(location.search);
  const deepLinkInvitationUrl = `buffl://invite/savegroup/${query.savingGroup}`;

  const shouldHideMobileContainer =
    query && query.step && query.step === 'completed';

  return (
    <div
      className={
        shouldHideMobileContainer
          ? styles.containerHiddenForMobile
          : styles.container
      }
    >
      <h1 className={styles.title}>
        {translations.YOU_ARE_INVITED_TO_SAVE_TOGETHER}
      </h1>

      <div className={styles.smallScreenText}>
        <p>
          <div className={`${styles.text} ${styles.mobileNewLine}`}>
            {translations.YOU_ARE_INVITED_TO_SAVE_TOGETHER_JOIN_TOGETHER}
          </div>
        </p>

        <div className={styles.smallText} style={{ marginBottom: 10 }}>
          {translations.DO_YOU_HAVE_BUFFL_APP}
        </div>
        <a className={styles.actionButton} href={deepLinkInvitationUrl}>
          {translations.OPEN_BUFFL_APP}
        </a>
        <div className={styles.splitterContainer}>
          <span className={styles.splitterText}>
            {translations.NOT_YET_ACCOUNT}
          </span>
        </div>
        <div
          className={styles.actionButton}
          role="presentation"
          onClick={() => setSavingGroupDeepLinkingPromptShow(false)}
        >
          {translations.CREATE_ACCOUNT_SAVING_GROUP}
        </div>
        <p>
          <div className={`${styles.smallText} ${styles.mobileNewLine}`}>
            {translations.DOWNLOAD_APP_AND_CREATE_ACCOUNT}
          </div>
        </p>
      </div>
    </div>
  );
};
